import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var EventManager = /*#__PURE__*/function () {
  function EventManager() {
    _classCallCheck(this, EventManager);

    this._listeners = [];
  }

  _createClass(EventManager, [{
    key: "addListener",
    value: function addListener(eventKind, listener) {
      var _this = this;

      var listen = {
        kind: eventKind,
        listener: listener
      };

      this._listeners.push(listen);

      return function () {
        _this._listeners.splice(_this._listeners.indexOf(listen), 1);
      };
    }
  }, {
    key: "fire",
    value: function fire(event, param) {
      return this._listeners.filter(function (value) {
        return value.kind === event;
      }).map(function (value) {
        return value.listener(param);
      });
    }
  }]);

  return EventManager;
}();